<template>
  <el-row class="el-title" style="position: relative;">
    <MainNavBarWapV2 :object-data="infoHeader" />

    <el-row class="list-shop__header top-spacing">
      <el-col :sm="24" class="custom-el-input">
        <el-col :sm="24">
          <iframe
            style="min-height: 700px; width:100%"
            :src="epay_link"
          ></iframe>
        </el-col>
      </el-col>
      <div v-loading="loadingData" style="min-height: 500px; width:100%"></div>
    </el-row>
  </el-row>
</template>
<script>
import GlobalAPI from "@/views/api/wap/global";
import { getInfoBooked } from "@/utils/booked";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
export default {
  name: "PaymentEpay",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},

  data() {
    return {
      loadingData: false,
      infoHeader: {
        title: "Cổng thanh toán Epay",
        isShowHomeIcon: true
      },
      isLoading: true,
      epay_link: null
    };
  },
  created() {
    this.getDataPayment();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getDataPayment() {
      const body = {
        type: "epay",
        money: getInfoBooked()?.payment_amount,
        data_provider: {
          transaction_id: getInfoBooked().transaction_id,
          general_bill_id: getInfoBooked().id_general_bill
        },
        provider: "general_bill"
      };
      this.loadingData = true;
      GlobalAPI.create_request_for_wap(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.error(error_msg);
          } else {
            this.epay_link = data.epay_link;
            console.log("error_code____________________", res);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    onHandleResultDialog(isSuccess) {
      this.handleShowResultDialog(isSuccess);
    }
  }
};
</script>

<style scoped>
.top-spacing {
  padding-top: 75px;
}
.el-title-buy-insurance {
  display: flex;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
}

.logo-wghn {
  display: block;
  width: 100%;
  height: 225px;
  object-fit: cover;
}

.el-item-in-background {
  /* padding-bottom: 20px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.center-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.center-container > * {
  max-width: 90%;
}

.el-user {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.right-align {
  text-align: right;
}

.el-row-info-user-buy {
  padding: 10px;
}

.button-wrapper {
  margin-top: auto;
}

.el-icon-back {
  padding-left: 11px;
  font-size: 20px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 55px;
  }
}
</style>
